import React, { FunctionComponent } from 'react';
import { Action } from 'redux';
import { connect, DispatchProp } from 'react-redux';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { alignSelectedItems } from '../../modules/annotations/paperActions';

type Props = DispatchProp<Action>;

const VerticallyAlign: FunctionComponent<Props> = ({ dispatch }) => (
  <Tooltip disableInteractive disableFocusListener id="remove-page-tooltip" title="Vertically Align">
    <div>
      <IconButton
        sx={{ borderRadius: 0 }}
        aria-label="Vertically Align"
        onClick={() => alignSelectedItems('vertical', dispatch)}
      >
        <FormatAlignCenterIcon sx={{ transform: 'rotate(0deg)' }} />
      </IconButton>
    </div>
  </Tooltip>
);

export default connect()(VerticallyAlign);
